import { useState } from 'react'
import { IconButton, Snackbar, Alert } from '@mui/material'
import { motion } from 'framer-motion'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import TwitterIcon from '@mui/icons-material/Twitter'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { trackSocialShare } from '../utils/analytics'
import { colors } from '../styles/theme'

const ShareButtons = ({ url, title, episodeSlug }) => {
  const [copied, setCopied] = useState(false)

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      trackSocialShare('copy_link', episodeSlug)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  const handleTwitterShare = () => {
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      title
    )}&url=${encodeURIComponent(url)}`
    window.open(tweetUrl, '_blank', 'noopener,noreferrer')
    trackSocialShare('twitter', episodeSlug)
  }

  const handleLinkedInShare = () => {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      url
    )}`
    window.open(linkedInUrl, '_blank', 'noopener,noreferrer')
    trackSocialShare('linkedin', episodeSlug)
  }

  const shareButtonSx = {
    backgroundColor: colors.bgCard,
    color: colors.info,
    '&:hover': {
      backgroundColor: colors.info,
      color: colors.textOnAccent,
    },
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-400 mr-2">Share:</span>

        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
          <IconButton onClick={handleTwitterShare} aria-label="Share on Twitter" sx={shareButtonSx}>
            <TwitterIcon />
          </IconButton>
        </motion.div>

        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
          <IconButton onClick={handleLinkedInShare} aria-label="Share on LinkedIn" sx={shareButtonSx}>
            <LinkedInIcon />
          </IconButton>
        </motion.div>

        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
          <IconButton onClick={handleCopyLink} aria-label="Copy link" sx={shareButtonSx}>
            <ContentCopyIcon />
          </IconButton>
        </motion.div>
      </div>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="success"
          sx={{
            backgroundColor: colors.info,
            color: colors.textOnAccent,
            fontWeight: 600,
          }}
        >
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  )
}

export default ShareButtons
